/**
 * @description: 输入框组件
 * @param {*} value 输入值（双向绑定）
 * @param {*} placeholder 输入框占位文本
 * @param {*} numberOnly 是否只允许数字输入（自定义参数名）
 * @param {*} width 输入框宽度（支持数字和百分比形式）
 * @returns {*} 输入框组件实例
 * @example <SmartInput v-model="inputValue" :placeholder="'请输入'" :numberOnly="true" :width="100" width="100%" />
 */
<template>
  <el-input
    v-model="inputValue"
    :style="{ width: typeof width === 'number' ? width + 'px' : width }"
    @input="handleInput"
    v-bind="$attrs"
    :placeholder="placeholder"
    :size="size"
    :maxlength="max"
  />
</template>

<script>
export default {
  name: 'SmartInput',
  props: {
    // 输入值（双向绑定）
    value: {
      type: [String, Number],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    // 是否只允许数字输入（自定义参数名）
    numberOnly: {
      type: Boolean,
      default: false
    },
    max:{
      type: Number,
      default: 99,

    },
    size:{
      type: String,
      default: 'mini',
    },
    // 输入框宽度（支持数字和字符串形式）
    width: {
      type: [String, Number],
      default: 'auto',
      validator: (val) => {
        if (typeof val === 'number') return val > 0
        if (typeof val === 'string') {
          return val === 'auto' || /^\d+(px|%)$/.test(val)
        }
        return false
      }
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleInput(value) {
      if (this.numberOnly) {
        // 优化后的数字过滤逻辑
        let filteredValue = value.replace(/[^\d.]/g, '')
        
        // 处理多个小数点的情况
        const parts = filteredValue.split('.')
        if (parts.length > 2) {
          filteredValue = parts[0] + '.' + parts.slice(1).join('')
        }
        
        // 处理以小数点开头的情况（可选）
        if (filteredValue.startsWith('.')) {
          filteredValue = '0' + filteredValue
        }
        
        // 更新值（如果过滤后不同）
        if (filteredValue !== value) {
          this.inputValue = filteredValue
        }
      }
    }
  }
}
</script>